import { Skeleton } from "@/block-system/brickz/components/ui/skeleton";

export function TableBlockSkeleton({
  hasTitle,
  canSearchRecords,
  canCreateRecords,
}: {
  hasTitle: boolean;
  canSearchRecords: boolean;
  canCreateRecords: boolean;
}) {
  return (
    <div className="flex flex-col gap-10">
      <TableBlockHeaderSkeleton
        hasTitle={hasTitle}
        canSearchRecords={canSearchRecords}
        canCreateRecords={canCreateRecords}
      />
      <TableBlockBodySkeleton />
    </div>
  );
}

function TableBlockHeaderSkeleton({
  hasTitle,
  canSearchRecords,
  canCreateRecords,
}: {
  hasTitle: boolean;
  canSearchRecords: boolean;
  canCreateRecords: boolean;
}) {
  return (
    <div className="flex flex-col gap-7">
      {hasTitle ? (
        <Skeleton className={"h-10 w-full min-w-[100px] max-w-[200px]"} />
      ) : null}

      <div className="flex flex-row flex-wrap justify-between gap-2">
        {canSearchRecords ? (
          <Skeleton className={"h-10 w-full sm:w-[248px] md:w-[360px]"} />
        ) : null}
        {canCreateRecords ? (
          <Skeleton className={"ml-auto h-10 w-full sm:w-32"} />
        ) : null}
      </div>
    </div>
  );
}

function TableBlockBodySkeleton() {
  /**
   * The number of columns and rows is arbitrary.
   */
  const numberOfColumns = 3;
  const columns = Array.from({ length: numberOfColumns }, (_, index) => index);

  const numberOfRows = 4;
  const rows = Array.from({ length: numberOfRows }, (_, index) => index);

  return (
    <div className={"rounded-large border border-border bg-card"}>
      {rows.map((rowIndex) => {
        return (
          <div
            className={
              "grid gap-4 border-b border-border px-4 py-4 last-of-type:border-none"
            }
            style={{
              gridTemplateColumns: `repeat(${numberOfColumns}, auto)`,
            }}
            key={rowIndex}
          >
            {columns.map((columnIndex) => {
              return <Skeleton key={columnIndex} className={"h-10 w-full"} />;
            })}
          </div>
        );
      })}
    </div>
  );
}
